<template>
  <div v-loading="loading">
    <div class="doc-box" style="">
      <div class="doc-top">
        <H3
          class="title ellipsis cursor"
          :title="item.title"
          @click="full(item.docId)"
        >
          {{ item.title }}</H3
        >
        <div class="tips ml15">
          <span class>创建时间:</span>
          <span class>{{ item.addTime | dateformat("YYYY年MM月DD日") }}</span>
          <span class="ml15">更新时间:</span>
          <span class>{{
            item.updateTime | dateformat("YYYY年MM月DD日")
          }}</span>
        </div>
        <div class="doc-info">
          <div class="article-introduction">
            <!-- //https://5b0988e595225.cdn.sohucs.com/q_70,c_zoom,w_640/images/20200329/e0a9e11d056c4c7c858baea0ec0efcac.jpeg -->
            <img
              v-if="item.CoverImage != null && item.CoverImage !== ''"
              width="130"
              height="95"
              :src="item.CoverImage"
              align="right"
              hspace="5"
              vspace="5"
              class="mr5"
            />
            <p @click="full(item.docId)" class="cursor">
              {{ item.intro }}
            </p>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="doc-bottom">
          <div
            class="doc-btn border cursor"
            @click="setTop"
            v-if="item.setTopTime === '' || item.setTopTime == null"
          >
            <span class="iconfont mr5">&#xe68a;</span>置顶
          </div>
          <div
            class="doc-btn border cursor issettop"
            @click="setTop"
            v-if="item.setTopTime !== '' && item.setTopTime != null"
          >
            <span class="iconfont mr5">&#xe68a;</span>已置顶
          </div>
          <div class="doc-btn border cursor" @click="full(item.docId)">
            <span class="iconfont mr5">&#xe611;</span>全文
          </div>
          <div @click="editArticles" class="doc-btn cursor">
            <span class="iconfont mr5">&#xe604;</span>编辑
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { SendPostData } from "../../assets/script/model";

export default {
  props: ["item"],
  data() {
    return {
      loading: false,
      popoverVisible: false,
      detailList: []
    };
  },
  computed: {
    insertDoc: {
      get() {
        return this.$store.state.editorControl.insertDoc;
      },
      set(val) {
        this.$store.state.editorControl.insertDoc = val;
      }
    },
    allContent: {
      get() {
        return this.$store.state.editorControl.allContent;
      },
      set(val) {
        this.$store.state.editorControl.allContent = val;
      }
    },
    getTitle: {
      get() {
        return this.$store.state.wycContent.getTitle;
      },
      set(val) {
        this.$store.state.wycContent.getTitle = val;
      }
    },
    editorShow: {
      get() {
        return this.$store.state.contents.editorShow;
      },
      set(val) {
        this.$store.state.contents.editorShow = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    rightShow: {
      get() {
        return this.$store.state.contents.rightShow;
      },
      set(val) {
        this.$store.state.contents.rightShow = val;
      }
    },
    leftShow: {
      get() {
        return this.$store.state.contents.leftShow;
      },
      set(val) {
        this.$store.state.contents.leftShow = val;
      }
    }
  },
  methods: {
    ...mapActions("api", ["ADocSetTop", "ADocDetail"]),

    async setTop() {
      let setTopTime = "";
      let successTips = "置顶成功";
      if (this.item.setTopTime) {
        successTips = "取消置顶成功";
        setTopTime = "";
      } else {
        setTopTime = new Date();
      }
      var result = await this.ADocSetTop({
        docId: this.item.docId,
        setTopTime: setTopTime
      });
      if (result.errorCode === 0) {
        this.$message({
          showClose: true,
          message: successTips,
          type: "success"
        });
        this.item.setTopTime = new Date();
        this.$emit("reload");
      } else {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
      }
    },
    full(id) {
      this.$router.push("/article/doc/" + id);
    },
    async editArticles() {
      if (this.wycShow) {
        this.rightShow = false;
        this.editorShow = true;
        this.wycShow = false;
        this.leftShow = true;
        let sendData = new SendPostData();
        sendData.btn = "finish";
        this.SendMessage(sendData);
      }

      let result = await this.ADocDetail({ docId: this.item.docId });
      if (result.errorCode === 0) {
        this.detailList = result.data;
        this.insertDoc.docId = this.item.docId;
        this.insertDoc.title = this.detailList.title;
        this.insertDoc.content = this.detailList.content;
        this.insertDoc.intro = this.detailList.intro;
        this.setSessionDocId(this.item.docId);
        // this.allContent = this.insertDoc.content;
        this.getTitle = this.insertDoc.title;
        this.insertConfig.setAllContent(this.insertDoc.content, "文集加载完成");
        localStorage.setItem(
          "lastEditorContent",
          JSON.stringify(this.insertDoc)
        );
      }
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";
.doc-box {
  font-weight: 500;
  background-color: #ffffff;
  // min-height: 240px;
  border-radius: 2px;
  position: relative;
  width: 440px;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #e3e8f7;
}
.doc-box:hover {
  box-shadow: 0px 0px 4px 2px #f0f5ff;
  cursor: pointer;
}
//标题
.doc-box .title {
  margin: 15px 15px 10px 15px;
  color: #333;
}
//时间
.doc-box .tips {
  font-size: 12px;
  margin: 0 15px;
  color: #999;
}
//内容
.doc-box .doc-info {
  margin-top: 13px;
  font-size: 12px;
  line-height: 2em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  margin: 10px 15px 15px 15px;
  color: #666;
}
.doc-box .doc-info p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  color: #666;
}
.doc-box .doc-bottom {
  display: flex;
  padding: 5px;
  height: 40px;
  border-top: 1px solid #e3e8f7;

  font-size: 12px;
  // position: absolute;
  // bottom: 0;
}
.doc-box .bottom {
  width: 100%;
  // position: absolute;
  // bottom: 0;
}
.doc-box .doc-bottom .doc-btn {
  flex: 1;
  display: flex;
  justify-content: center; //左右
  align-items: center; //上下
}
.doc-box .doc-bottom .border {
  border-right: 1px solid #e3e8f7;
}
// 已置顶
.doc-box .issettop {
  color: green;
}
</style>
